import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { compose, withStateHandlers } from 'recompose';

import { Marker, InfoWindow } from 'react-google-maps';

const enhance = compose(
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen:
        ({ isOpen }, { onClick }) =>
        (e) => {
          if (onClick) {
            onClick(e, !isOpen);
          }
          return {
            isOpen: !isOpen,
          };
        },
    }
  )
);

const MarkerWithInfoWindow = ({ content, isOpen, onToggleOpen, ...props }) => {
  return (
    <Marker {...props} onClick={onToggleOpen}>
      {!!isOpen && (
        <InfoWindow onCloseClick={onToggleOpen}>
          <Fragment>{content}</Fragment>
        </InfoWindow>
      )}
    </Marker>
  );
};

MarkerWithInfoWindow.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  content: PropTypes.any,
  onToggleOpen: PropTypes.func.isRequired,
};

export default enhance(MarkerWithInfoWindow);
